var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"auth",staticStyle:{"padding":"0 200px"}},[_c('Header'),_c('div',{staticClass:"content"},[_c('router-view')],1),_c('servicepopup')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }